<template>
    <div class="copy-dtx-table project-list-table">
        <table class="" :class="{ admin: isTenantAdmin }">
            <thead v-if="showHeader">
                <tr class="m">
                    <th v-overflow-tooltip>Name</th>
                    <th>location</th>
                    <th v-overflow-tooltip>Supervisors</th>
                    <th v-overflow-tooltip v-if="showActions">Action</th>
                </tr>
            </thead>
            <tbody v-if="!loading && displayData.length">
                <tr class="s pointer" v-for="row in displayData" :key="row.id" @click="factorySelected(row)">
                    <td class="elipsis-text " v-overflow-tooltip>{{ row.name || "--" }}</td>
                    <td class="elipsis-text" v-overflow-tooltip> {{ row?.address?.city }}, {{ row?.address?.state }} </td>
                    <td>
                    <div class="avatar-container flex">
                    <avatar v-for="user in row.formattedSupervisors" :key="user.id" :user="user.associated_user"
                      :title="getUserTooltip(user.associated_user)" style="margin-right: -13.5px"/>
                    <avatar style="margin-right: -13.5px" v-if="row.exceededCount" :exceeded-count="row.exceededCount" :title="row.exceededCount + ' ' + 'more'"/>
                  </div>
                    </td>
                    <td v-if="showActions" class="action-column">
                        <div class="action-icons">
                            <img src="~@/assets/images/pencil.svg" class="edit pointer" alt="" v-tooltip="'Edit'"
                                @click.stop="$emit('edit', row)" />
                        </div>
                    </td>
                </tr>
            </tbody>
            <tbody v-else-if="!loading && displayData.length === 0">
                <tr>
                    <td :colspan="showActions ? 4 : 3" class="no-data">
                        <div class="center">
                            No Data Found
                        </div>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td :colspan="showActions ? 4 : 3">
                        <div class="center">
                            <loading-circle />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import LoadingCircle from '@/components/common/loadingCircle.vue'
import { genericFormatDate } from '@/utils/date'
import { mapGetters } from 'vuex'
import ConfirmationDialog from '@/plugins/confirmationDialog'
import Avatar from '@/components/common/avatar.vue'

export default {
  components: { LoadingCircle, Avatar },
  filters: {
    genericFormatDate
  },
  name: 'factory-table',
  props: {
    projectList: {
      type: Array,
      default: () => []
    },
    pageNumber: {
      type: [Number, String],
      default: 1
    },
    perPage: {
      type: [Number, String],
      default: 10
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    externalCollaborator: {
      type: String
    }
  },
  computed: {
    ...mapGetters(['user', 'getUserById', 'collaborator', 'isOnFactoryLevel', 'isOnProjectLevel']),
    ...mapGetters(['isTenantAdmin']),
    displayData () {
      return this.projectList.slice(
        (this.pageNumber - 1) * this.perPage,
        this.pageNumber * this.perPage
      )
    },
    isTenantAdmin () {
      return (
        this.user.tenantLevelRole === 'ADMIN' && !this.externalCollaborator
      )
    },
    showActions () {
      return (!this.collaborator && !this.isOnFactoryLevel && !this.isOnProjectLevel && this.isTenantAdmin)
    }
  },
  methods: {
    factorySelected (factory) {
      this.$emit('factory-selected', factory)
    },
    getUserTooltip (user) {
      if (!user) return ''
      return `${user?.first_name || ''} ${user?.last_name || ''}`
    },
    getFullName (obj) {
      const user = obj?.project_user_associations[0]?.associated_user
      if (user) {
        return user?.first_name + ' ' + user?.last_name
      }
      return '--'
    },
    openDeleteConfirmModal (project) {
      ConfirmationDialog(`Are you sure to delete the project ${project.name}`, (res) => {
        if (res) {
          this.$emit('delete', project)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.no-data {
    text-align: center;
    vertical-align: middle;
}

.vendorName {
  align-items: center;
  font-size: var(--text-s);
  color:#8c8989;
}

.project-list-table {
    margin-top: 10px;
    max-height: calc(100vh - 250px);

    table th {
        z-index: 1;
    }

    .map {
        z-index: 0;
    }
}
</style>
